import React from 'react'
import { IBadgeProps } from './interfaces'
import { AndroidFilled } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { DeliveryChannel } from '@pushly/aqe/lib/enums/delivery-channels'

export const NativeAndroidBadge: React.FC<React.PropsWithChildren<React.PropsWithChildren<IBadgeProps>>> = (props) => {
    const badge = (
        <span className="icon-android">
            <AndroidFilled />
        </span>
    )

    return (
        <span className="delivery-channel-android-badge">
            {props.hideTooltip ? (
                badge
            ) : (
                <Tooltip
                    title={
                        props.tooltip ||
                        `Delivery Channel: ${DeliveryChannel.getLongName(DeliveryChannel.NATIVE_ANDROID)}`
                    }
                >
                    {badge}
                </Tooltip>
            )}
        </span>
    )
}
